import axios from "axios";

import { useRouter } from "src/routes/hooks";

import { HOST_API } from "../../config-global";


const axiosInstance = axios.create({ baseURL: HOST_API });

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const router = useRouter();

    if (error.response.status === 401) {
      // Token inválido o expirado, redirigir al login
      localStorage.removeItem('token');
      router.replace('/login');
    }

    return Promise.reject(error.response.data || "Something went wrong");
  }
);

export default axiosInstance;

export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, {
    ...config,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('token') || null}`,
    },
  });

  return res.data;
};

export const postFetcher = async (url, { arg }) => {
  try {
    const response = await axiosInstance.post(url, arg, {
      headers: {
        // 'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token') || null}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const endpoints = {
  auth: {
    login: '/api/auth/login'
  },
  clo: {
    active: '/api/clo',
    nur: '/api/merch/getNurByClo',
    ruta: 'api/merch/getRutaByClo'
  },
  ux: {
    filter: '/api/ux/filter',
    list: '/api/ux/paginate',
    countOnRoute: '/api/ux/cliente/cantidad/ruta',
    distanceAndTime: '/api/ux/cliente/distance',
  },
  customer: {
    requestItoClient: '/api/requestItoClient/list/cliente',
    requestItoClientData: '/api/requestItoClient',
    search: '/api/requestItoClient/getItos',
    searchFilter: '/api/requestItoClient/getItos',
    detail: '/api/merch/customer',
    latestVisit: '/api/pwpdv/latest',
    latestVisit_tree: '/api/pwpdv/latest_tree',
    filter: '/api/merch/locations',
    active_credits: '/api/cliente_creditos/credito/activo',
    credito: '/api/pwst_ctescredito_lasth',
    pdvGraficDataByYear: '/api/pwpdv/byYear',
    dtyGraphDataByYear: '/api/dty/period',
    dtyGraphDataByYearMonth: '/api/dty/period/month',
    dtyTableDataToDayByYear: '/api/dty/year-to-day',
    otc: '/api/pwst-venta-otc-cliente-sftps/accumulated-year',
    comboPorCliente: '/api/pwst-combos-cliente-sftps/last-record',
    accumalatedCombosByClient: '/api/pwst-combos-cliente-sftps/accumulated-year',
  },
  merch: {
    potencial: '/api/merch/potencial',
  },
  gulldata: {
    detail: '/api/gulldata'
  },
  quality_execution_assigments: {
    last_execution: '/api/quality_execution_assignments/lastexecution',
    last_execution_ec_id: '/api/quality_execution_assignments/lastexecutionById',
    last_execution_request: '/api/quality_execution_assignments/lastexecutionrequest',
    grafic: '/api/quality_execution_assignments/graficaPwpdvs',
    filter: '/api/quality_execution_assignments/filter'
  },
  dty: {
    last_sale: '/api/dty/lastsale',
  },
  last_visit_dz: {
    detail: '/api/pwpdv/latest'
  },
  domicilio: {
    estado: '/api/estado',
    municipio: (id_state) => `/api/municipio/by_state?state=${id_state}`,
  },
  forms: {
    telefono: '/api/customer_cellphone',
    rutas: '/api/ruta',
    clos: '/api/clo',
    opciones_captamina: '/api/opciones_captamina',
    opciones_incidencias: '/api/opciones_incidencias',
    post_captamina: '/api/captamina',
    post_hetMerch: '/api/heet',
    post_homecres: '/api/homecres',
    post_ecmerch: '/api/merch_calidad',
    post_credito: '/api/credito_cliente',
    post_editarCliente: '/api/requestItoClient',
    post_visitaMerchERP: '/api/ventas_merch_visitas_campo',
    ventas_merch_visitas_campo: '/api/ventas_merch_visitas_campo/lastexecution/ten',
    post_incidencia: '/api/incidencias',
    historial_cliente_captamina: '/api/captamina',
    historial_cliente_credito: '/api/credito_cliente',
    historial_cliente_incidencia: '/api/incidencias',
  },
  ec: {
    ecRuta: 'api/form/interview/ecruta?session=',
    captamina: 'api/captamina/consultar?id=',
    telefono: 'api/customer_cellphone/interview/',
    heets: 'api/heet/',
    credito: 'api/credito_cliente/interview/',
    homecres: 'api/homecres/',
    merch: 'api/merch_calidad/',
    solicitud_ito_clientes: 'api/requestItoClient/',
    incidencias: 'api/incidencias/interview/',
    homemes: 'api/homeme/show/',
    ventas_merch: 'api/ventas_merch_visitas_campo/',
  }


}

export const tipoToEndpoint = {
  'ECRUTA': endpoints.ec.ecRuta,                 
  'CAPTAMIÑA': endpoints.ec.captamina,                     
  'CAPTAMINA': endpoints.ec.captamina,                     
  'TELÉFONO CLIENTE': endpoints.ec.telefono,             
  'TELEFONO': endpoints.ec.telefono,             
  'HET': endpoints.ec.heets,                              
  'CREDITO CLIENTE': endpoints.ec.credito,            
  'HOMECRES': endpoints.ec.homecres,                      
  'MERCH': endpoints.ec.merch,                            
  'EC MERCH': endpoints.ec.merch,                            
  'SOLICITUD ITO CLIENTES': endpoints.ec.solicitud_ito_clientes,  
  'INCIDENCIAS VENTAS': endpoints.ec.incidencias,            
  'HOMEMES': endpoints.ec.homemes,                            
  'VENTAS MERCH VISITAS': endpoints.ec.ventas_merch,
};